import { render, staticRenderFns } from "./ServiceDrawer.vue?vue&type=template&id=2003852e&scoped=true"
import script from "./ServiceDrawer.vue?vue&type=script&lang=js"
export * from "./ServiceDrawer.vue?vue&type=script&lang=js"
import style0 from "./ServiceDrawer.vue?vue&type=style&index=0&id=2003852e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003852e",
  null
  
)

export default component.exports